import { render, staticRenderFns } from "./Equipment.vue?vue&type=template&id=6b3cfb3a&scoped=true&"
import script from "./Equipment.vue?vue&type=script&lang=js&"
export * from "./Equipment.vue?vue&type=script&lang=js&"
import style0 from "./Equipment.vue?vue&type=style&index=0&id=6b3cfb3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3cfb3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
